import { Carousel } from './classes/Carousel.js';

function initCarousels () {
    document.querySelectorAll('.carousel').forEach(function (el) {
        new Carousel(el);
    });
}

document.addEventListener('DOMContentLoaded', initCarousels);
